import { SKELETAL_MUSCLE_MASS_INFO, SKELETAL_MUSCLE_MASS_PANEL_TITLE, SKELETAL_MUSCLE_MASS_POPOVER_TITLE } from '../../../assets/ApplicationCopy';
import { CONSTANTS } from '../../../assets/UIConstants';
import { Scan } from '../../../data_layer/models/Scan';
import { FullSummaryCategories } from '../../pages/FullSummary';
import { AbstractPanel } from './AbstractPanel';

export class SkeletalMuscleMass extends AbstractPanel {
    protected panelId: string = FullSummaryCategories.SkeletalMuscleMass;
    protected panelTitle: string = SKELETAL_MUSCLE_MASS_PANEL_TITLE;
    protected popoverTitle: string = SKELETAL_MUSCLE_MASS_POPOVER_TITLE;
    protected popoverBody: string | JSX.Element = SKELETAL_MUSCLE_MASS_INFO;

    protected fullSummaryLinkPath: string = 'skeletal-muscle-mass';

    protected graphUnit: string = 'lbs';

    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.skeletalMuscleMassPounds;
    }

    protected graphColor: string = CONSTANTS.COLORS.THEME_BLUE;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/FatFreeMass.tsx